import autosize from 'autosize';
import { Component } from '@mycolorway/tao';
import eventListenerMixin from 'next/javascripts/mixins/event-listener-mixin';
import { camelCase } from 'next/javascripts/modules/utils';
import 'next/stylesheets/components/todo-custom-field';

Component('tr-todo-custom-field', {
  mixins: [eventListenerMixin],

  properties: {
    fieldType: String,
    key: String,
    empty: Boolean,
  },

  ready() {
    this.emptyBtn = this.querySelector('.empty');
    const method = camelCase(`init_field_type_${this.fieldType}`);
    if (this[method]) this[method]();
  },

  notifyChange(value) {
    this.namespacedTrigger('change', {
      detail: value,
      bubbles: true,
    });
  },

  initFieldTypeSelect() {
    this.selectorField = this.querySelector('tr-selector-field');
    this.listenTo(this.selectorField, 'tao:change', (event) => {
      event.stopPropagation();
      this.empty = !event.detail;
      this.notifyChange(event.detail);
    });
  },

  initFieldTypeMultiSelect() {
    this.selectorField = this.querySelector('tr-multiple-select-field');
    this.listenTo(this.selectorField, 'tao:change', (event) => {
      event.stopPropagation();
      this.empty = !event.detail.length;
      this.notifyChange(event.detail);
    });
  },

  initFieldTypeNumber() {
    this.input = this.querySelector('input');
    this.inputWrapper = this.querySelector('.input-wrapper');
    this.result = this.querySelector('.result');

    const updateResult = (num) => {
      this.result.num = num;
      this.result.format();
    };

    updateResult(this.input.value);

    this.listenTo(this.inputWrapper, 'click', () => {
      this.empty = false;
      this.classList.add('editing');
      this.input.focus();
    });
    this.listenTo(this.input, 'blur', () => {
      this.empty = !this.input.value;
      updateResult(this.input.value);
      this.classList.remove('editing');
      this.notifyChange(this.input.value);
    });
    this.listenTo(this.input, 'keydown', (event) => {
      event.stopPropagation();
      if (event.code === 'Enter' || event.code === 'Escape') {
        updateResult(this.input.value);
        this.classList.remove('editing');
        this.input.blur();
      }
    });
  },

  initFieldTypeString() {
    this.input = this.querySelector('textarea');
    this.result = this.querySelector('.result');
    autosize(this.input);

    const re = /(https?:\/\/|www\.)[\w\-.?&=/#%:,@!+]+/ig;
    const setContent = (content) => {
      this.result.innerHTML = content.replace(re, '<a href="$&" target="_blank">$&</a>');
    };

    setContent(this.input.value);

    this.inputWrapper = this.querySelector('.input-wrapper');
    this.listenTo(this.inputWrapper, 'click', () => {
      this.classList.add('editing');
      this.empty = false;
      this.input.focus();
      autosize.update(this.input);
    });
    this.listenTo(this.input, 'blur', () => {
      this.empty = !this.input.value;
      setContent(this.input.value);
      this.classList.remove('editing');
      this.notifyChange(this.input.value);
    });
    this.listenTo(this.input, 'keydown', (event) => {
      event.stopPropagation();
      if (event.code === 'Enter' || event.code === 'Escape') {
        setContent(this.input.value);
        this.classList.remove('editing');
        this.input.blur();
      }
    });
  },

  initFieldTypeDate() {
    this.dateField = this.querySelector('tr-date-picker-field');
    this.listenTo(this.dateField, 'tao:change', (event) => {
      event.stopPropagation();
      this.empty = !event.detail;
      this.notifyChange(event.detail);
    });
  },

  initFieldTypeMember() {
    let multiple = false;

    this.selectorField = this.querySelector('tr-selector-field');
    if (!this.selectorField) {
      multiple = true;
      this.selectorField = this.querySelector('tr-multiple-select-field');
    }

    this.listenTo(this.selectorField, 'tao:change', (event) => {
      event.stopPropagation();
      this.empty = multiple ? event.detail.length === 0 : !event.detail;
      this.notifyChange(event.detail);
    });
  },

  initFieldTypeBoolean() {
    this.listenTo(this.querySelector('tr-checkbox-field'), 'tao:change', (event) => {
      event.stopPropagation();
      this.notifyChange(event.detail.checked);
    });
  },
});
